import { Property } from "../../global/types";

const FALLBACK_SEARCH_CITY = "Fortaleza";
const FALLBACK_SEARCH_UF = "CE";

/**
 * Unavailable listings should send the visitor to the search page of the same
 * city when it is known, so the fallback city is only used for pure 404s.
 */
export function buildSearchLink(property?: Property): string {
  const city = property?.address?.city?.trim() || FALLBACK_SEARCH_CITY;
  const uf = property?.address?.uf?.trim() || FALLBACK_SEARCH_UF;

  return `/search/?city=${encodeURIComponent(city)}&UF=${encodeURIComponent(uf)}`;
}
